import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import UserSidebar from "../user/userSidebar";
import UserHeader from "../user/userHeader";
import { useSessionTimeout } from "../hooks/useSessionTimeout";

const styles = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #e0e7ff, #d1d5db)",
    fontFamily: "'Inter', 'Poppins', sans-serif",
    position: "relative",
  },
  main: (sidebarOpen, isMobile) => ({
    flex: 1,
    minWidth: 0,
    transition: "margin-left 0.3s ease",
    marginLeft: isMobile ? 0 : (sidebarOpen ? 200 : 60),
    display: "flex",
    flexDirection: "column",
    width: isMobile ? "100%" : "auto",
  }),
  body: (isMobile) => ({
    flex: 1,
    padding: isMobile ? 15 : 28,
    background: "#fff",
    minHeight: 0,
    overflowX: "auto",
    borderRadius: isMobile ? 10 : 20,
    margin: isMobile ? 10 : 28,
    boxShadow: "0 6px 23px rgb(62 63 104 / 18%)",
  }),
};

export default function UserLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  
  // Enable session timeout monitoring
  useSessionTimeout('user');

  useEffect(() => {
    let previousWidth = window.innerWidth;
    
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      const mobile = currentWidth < 992;
      const wasMobile = previousWidth < 992;
      
      setIsMobile(mobile);
      
      // Only auto-close when switching FROM desktop TO mobile, not when sidebar state changes
      if (mobile && !wasMobile) {
        setSidebarOpen((prev) => prev ? false : prev);
      }
      
      previousWidth = currentWidth;
    };

    window.addEventListener('resize', handleResize);
    // Initial check - only close if already mobile on mount
    if (window.innerWidth < 992 && sidebarOpen) {
      setSidebarOpen(false);
    }

    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty dependency array - only run on mount/unmount

  const handleOverlayClick = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      {/* Overlay for mobile sidebar */}
      {isMobile && sidebarOpen && (
        <div
          className="user-sidebar-overlay active"
          onClick={handleOverlayClick}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 99,
            display: "block",
            transition: "opacity 0.3s ease",
          }}
        />
      )}
      
      <UserSidebar 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={setSidebarOpen}
        isMobile={isMobile}
      />
      
      <div style={styles.main(sidebarOpen, isMobile)}>
        <UserHeader 
          sidebarOpen={sidebarOpen} 
          setSidebarOpen={setSidebarOpen}
          isMobile={isMobile}
        />
        <div style={styles.body(isMobile)}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
